import { FC } from 'react';
import {
	THandleAction,
	TShowButtons,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { ItemWithId } from 'services/constants/types';

export type TEasTableProps<T extends ItemWithId> = {
	tableStructure: TTableStructure<keyof T>[];
	itemsIsLoading: boolean;
	items: T[] | null;
	handleAction: THandleAction;
	handleLink?: (id: number) => void;
	skeletonRows?: any[];
	highlightedRow?: number | null;
	name?: string;
	showButtons?: TShowButtons[];
	checkedIds: number[];
	setCheckedIds: (ids: number[]) => void;
	CustomComponent?: FC<{ item: T }>;
};

export enum ECheckedAll {
	ALL = 'ALL',
	NO_ONE = 'NO_ONE',
	SOME = 'SOME',
}
